<template>
  <div class="data-visualization">
    <app-header></app-header>

    <!-- 轮播图 -->
    <div class="swiper-box">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(slide, index) in carouselSlides" :key="index">
          <img :src="slide.bgImage" alt="" />
          <div class="slide-content">
            <div class="container">
              <div class="slide-text-content">
                <p class="slide-en-title">{{ slide.enTitle }}</p>
                <h1 class="slide-title">{{ slide.title }}</h1>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- 小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 数据可视化模块 -->
    <section class="section section01">
      <div class="container">
        <div class="flexBox">
          <div class="item">
            <div class="icon icon1"></div>
            <h3 class="tag">全国地图可视化</h3>
            <p class="desc">省份覆盖、终端密度、团队分布</p>
          </div>
          <div class="item">
            <div class="icon icon2"></div>
            <h3 class="tag">团队规模</h3>
            <p class="desc">团队长数、业务员数、活跃率</p>
          </div>
          <div class="item">
            <div class="icon icon3"></div>
            <h3 class="tag">终端规模</h3>
            <p class="desc">药店、诊所、民营医院总量与开发进度</p>
          </div>
          <div class="item">
            <div class="icon icon4"></div>
            <h3 class="tag">业绩大盘</h3>
            <p class="desc">实时业绩、月度趋势、年度累计、区域排行</p>
          </div>
          <div class="item">
            <div class="icon icon5"></div>
            <h3 class="tag">渠道健康度</h3>
            <p class="desc">绑定率、活跃率、动销率、合规率</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 流程对比图 -->
    <section class="section section02">
      <div class="container">
        <div class="flexBox">
          <div class="process-item process-1">
            <div class="process-content">
              <h3 class="process-title">从过去</h3>
              <p class="process-desc">"看不见、管不住、算不清"</p>
            </div>
          </div>
          <div class="process-item process-2">
            <div class="process-content">
              <h3 class="process-title">到现在</h3>
              <p class="process-desc">"看得见、管得好、算得准"</p>
            </div>
          </div>
          <div class="process-item process-3">
            <div class="process-content">
              <p class="process-desc">正实现医药广阔市场精细化 数字化、智能化管理</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'DataVisualization',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'slide',
      },
      carouselSlides: [
        {
          bgImage: require('@/assets/DataVisualization/banner01.png'),
          enTitle: 'A MAP OF NATIONAL CHANNELS AND A GAME OF DATA DECISION-MAKING',
          title: '全国渠道一张图 · 数据决策一盘棋',
        },
        {
          bgImage: require('@/assets/DataVisualization/banner01.png'),
          enTitle: 'A MAP OF NATIONAL CHANNELS AND A GAME OF DATA DECISION-MAKING',
          title: '全国渠道一张图 · 数据决策一盘棋',
        },
        {
          bgImage: require('@/assets/DataVisualization/banner01.png'),
          enTitle: 'A MAP OF NATIONAL CHANNELS AND A GAME OF DATA DECISION-MAKING',
          title: '全国渠道一张图 · 数据决策一盘棋',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.data-visualization {
  padding-top: 80px;
}

.section-title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  height: 53px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
  margin: 0;
}

/* 轮播图样式 */
.swiper-box {
  width: 100%;
  height: 800px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide-content {
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-container) {
  height: 100%;
}
:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  margin: 0 18px !important;
  opacity: 1 !important;
  &.swiper-pagination-bullet-active {
    border-radius: 5px 5px 5px 5px;
    width: 56px;
  }
}
.slide-text-content {
  text-align: center;
  color: #fff;
}

.slide-en-title {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 2px;
  opacity: 0.9;
  text-transform: uppercase;
}

.slide-title {
  font-size: 64px;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* 数据可视化模块 */
.section01 {
  background: linear-gradient(180deg, #1ca19630 0%, #ffffff 100%);
  height: 735px;
  padding-top: 150px;
  padding-bottom: 75px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .flexBox {
    display: flex;
    max-width: 1200px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 30px 33px;

    .item {
      width: 378px;
      height: 240px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border-radius: 30px;
      box-shadow: 0px 4px 10px 0px #1ca19633;
      background: #ffffff;
      padding: 43px 0 34px;
      box-sizing: border-box;

      .icon {
        width: 100px;
        height: 86px;
        margin-bottom: 18px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.icon1 {
          background: url('@/assets/DataVisualization/icon01.png') no-repeat center center;
          background-size: auto 100%;
        }
        &.icon2 {
          background: url('@/assets/DataVisualization/icon02.png') no-repeat center center;
          background-size: auto 100%;
        }
        &.icon3 {
          background: url('@/assets/DataVisualization/icon03.png') no-repeat center center;
          background-size: auto 100%;
        }
        &.icon4 {
          background: url('@/assets/DataVisualization/icon04.png') no-repeat center center;
          background-size: auto 100%;
        }
        &.icon5 {
          background: url('@/assets/DataVisualization/icon05.png') no-repeat center center;
          background-size: auto 100%;
        }
      }

      .tag {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 32px;
        height: 32px;
        margin: 0;
        letter-spacing: 0;
        text-align: center;
        color: #000000;
        margin-bottom: 3px;
      }

      .desc {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0;
        text-align: center;
        color: #000000;
        margin: 0;
      }
    }
  }
}

/* 流程对比图 */
.section02 {
  background: #ffffff;
  height: 482px;
  padding-top: 85px;
  padding-bottom: 200px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .flexBox {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .process-item {
      position: relative;
      width: 320px;
      height: 160px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.process-1 {
        z-index: 3;
        margin-right: -54px;
        .process-content {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 238px;
          transform: translate(-50%, -50%);
          text-align: center;
          z-index: 2;

          .process-title {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-style: normal;
            font-size: 18px;
            line-height: 24px;
            color: #000000;
            margin: 0 0 10px 0;
            text-align: left;
          }

          .process-desc {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-style: normal;
            font-size: 18px;
            line-height: 24px;
            color: #000000;
            margin: 0;
            text-align: left;
          }
        }

        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background: url('@/assets/DataVisualization/icon06.png') no-repeat center;
          background-size: 100% 100%;
          border-radius: 80px;
        }
      }

      &.process-2 {
        z-index: 2;
        .process-content {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 238px;
          transform: translate(-50%, -50%);
          text-align: center;
          z-index: 2;

          .process-title {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-style: normal;
            font-size: 18px;
            line-height: 24px;
            color: #000000;
            margin: 0 0 10px 0;
            text-align: left;
          }

          .process-desc {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-style: normal;
            font-size: 18px;
            line-height: 24px;
            color: #000000;
            margin: 0;
            text-align: left;
          }
        }

        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background: url('@/assets/DataVisualization/icon07.png') no-repeat center;
          background-size: 100% 100%;
          border-radius: 80px;
        }
      }

      &.process-3 {
        margin-left: -55px;
        .process-content {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 216px;
          transform: translate(-50%, -50%);
          text-align: center;
          z-index: 2;

          .process-title {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-style: normal;
            font-size: 18px;
            line-height: 24px;
            color: #000000;
            margin: 0 0 10px 0;
            text-align: left;
          }

          .process-desc {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-style: normal;
            font-size: 16px;
            line-height: 24px;
            color: #666666;
            margin: 0;
            text-align: left;
          }
        }

        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background: url('@/assets/DataVisualization/icon08.png') no-repeat center;
          background-size: 100% 100%;
          border-radius: 80px;
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
}

@media (max-width: 768px) {
}
</style>
